/**
 * Destinations this tenant operates.
 *
 * Explicit list when present. Otherwise the partner marketplace (POC
 * merchants). Otherwise every configured marketplace (legacy / multi).
 */
export function activatedMarketplaceIds(tenantProfile, marketplaceOptions) {
  const explicit = tenantProfile?.activatedMarketplaceIds;
  if (Array.isArray(explicit) && explicit.length > 0) {
    return explicit.filter(Boolean);
  }

  const partnerId = tenantProfile?.partnerMarketplaceId;
  if (partnerId) return [partnerId];

  return (marketplaceOptions ?? [])
    .map((m) => m.value ?? m.id)
    .filter(Boolean);
}

export function marketplaceLabel(id, marketplaceOptions, fallback) {
  if (!id) return fallback ?? null;
  const hit = (marketplaceOptions ?? []).find(
    (m) => (m.value ?? m.id) === id,
  );
  return hit?.label ?? hit?.name ?? fallback ?? null;
}
